import { useIntl } from 'react-intl'
import { toast } from '@contrast-security-inc/design-system-alerts'
import { useCsvAsyncDownload } from '../api/use-csv-async-download'

interface Props {
  organizationID: string
  csvOptions: object
}

export function ShowCsvAsyncDownloadToast({
  organizationID,
  csvOptions
}: Props) {
  const { formatMessage } = useIntl()

  const { error } = useCsvAsyncDownload({
    organizationUuid: organizationID,
    csvOptions
  })

  if (error) {
    toast(
      formatMessage({
        id: 'detail_csvAsyncDownload_failedDownloadInitialization'
      }),
      {
        variant: 'error'
      }
    )
  } else {
    toast(
      formatMessage({
        id: 'detail_csvAsyncDownload_successfulDownloadInitialization'
      })
    )
  }

  return null
}
